module.exports = __webpack_public_path__ + "statics/img/5.61088e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/wap/5.png
// module id = Ii04
// module chunks = 1